import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from '../pages/Layout';
import Login from '../pages/login';
import Register from '../pages/register';
import Reset from '../pages/reset';
import UserCenter from '../pages/user-center';

export default function RouteView() {

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/*" element={<Layout />}></Route>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/reset" element={<Reset />} />
                <Route path="/usercenter/*" element={<UserCenter />} />
            </Routes>
        </BrowserRouter>
    )
}
